export const marketPlace={
  TH:{
    choose_file:"กรุณาเลือกไฟล์เพื่ออัพเดทข้อมูล:",
    save:"บันทึก",
    saved:"ข้อมูลถูกบันทึกเรียบร้อยแล้ว!!",
    click_data:"กดเลือกข้อมูลบนตารางเพื่อโฟกัสตำแหน่งข้อมูล",
    place_name:"ชื่อสถานที่"
  },
  EN:{
    choose_file:"choose file to update data:",
    save:"save",
    saved:"data was saved!!",
    click_data:"click on row data to focus data's position",
    place_name:"place name"
  }
}
